import EventBase from './EventBase'
import EventID from './EventID'

/**
 *  304  -  准备转场
 */

export default class EventPlanConvertScene extends EventBase {
  /**
   * 准备转场构造函数
   */
  constructor() {
    super()
    this.Parameter = ['']
  }

  /**
   * 事件ID
   */
  Code = EventID.PlanConvertScene

  /**
   * 获得该事件在事件列表的描述信息
   */
  /// <returns>事件描述信息</returns>
}
